export const keywords: string[] = [
  "precision",
  "simplify",
  "exactFractions",
  "fractionsLimit",
  "consoleDebug",
  "context",
  "true",
  "false",
  "pointOne",
  "pointTwo",
  "pointX",
  "pointY",
  "pointZ",
  "number",
  "notation",
  "wordSize",
  "lowerExp",
  "upperExp",
  "fraction",
  "truncate",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "and",
  "or",
];
